<template>
  <span v-if="acceptsCashOnDelivery" class="cash-on-delivery-tag">Pago contra entrega</span>
</template>

<script>
import { acceptsCashOnDelivery } from '@/utils/scharffPoint'

export default {
  props: {
    point: { required: false, default: null },
  },
  computed: {
    // Today every point of sale accepts it, but the user has no way of knowing that, so it is
    // stated on its own tag.
    acceptsCashOnDelivery() {
      return acceptsCashOnDelivery(this.point)
    },
  },
}
</script>

<style lang="scss" scoped>
.cash-on-delivery-tag {
  display: inline-block;
  align-self: flex-start;
  width: fit-content;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  white-space: nowrap;
  background: #DBEAFE;
  color: #1E40AF;
}
</style>
